@import '../../../global/global.pcss';
@import '../../common/item-list/styles/mixins.pcss';
@import '../../common/item-list/styles/placeholders.pcss';

@mixin atomic-grid-clickable-elements;
@mixin atomic-grid-display-common;

:host {
  display: block;
}

/**
 * @prop --atomic-recs-number-of-columns: Number of columns for the recommendation list.
 */
.list-root {
  @mixin atomic-grid-with-cards;
  grid-template-columns: repeat(var(--atomic-recs-number-of-columns, 1), minmax(0, 1fr));
}

[part='label'] {
  font-family: var(--atomic-font-family);
  font-size: var(--atomic-text-2xl);
  font-weight: var(--atomic-font-bold);
}
